import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HtmlBase, PropertyData, QueovalItem } from '../../../../models';
import { BaseAddOnComponent } from '../base-addon.component';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-aspx',
  templateUrl: './aspx.component.html',
  styleUrls: ['./aspx.component.css']
})

export class AspxComponent extends BaseAddOnComponent implements OnInit {

  @Input('input') input: PropertyData;
  @Output() setInput: EventEmitter<HtmlBase> = new EventEmitter<HtmlBase>(true);

  constructor() { super(); }

  ngOnInit(): void { }

  navig(button: HtmlBase, value: string): void {
    const params: Array<QueovalItem> = button.OnClickParams;
    for (const param of params) {
      if (param.Value === button.Code) {
        param.Text = value;
      }
    }
    if (params.length > 0) {
      button.OnClick = `${button.OnClick}?${params[0].Value}=${params[0].Text}`;
      if (params.length > 1) {
        for (let i: number = 1; i < params.length; i++) {
          button.OnClick += `&${params[i].Value}=${params[i].Text}`;
        }
      }
    }
    this.setInput.emit(button);
  }
}
